/*
 *
 * StudentsDetail reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_STUDENT,
  LOAD_STUDENT_SUCCESS,
  LOAD_STUDENT_ERROR,
  CHANGE_STUDENT,
  CHANGE_STUDENT_SUCCESS,
  CHANGE_STUDENT_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemData: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const studentsDetailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      // Load
      case LOAD_STUDENT:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_STUDENT_SUCCESS:
        draft.itemData = action.itemData;
        draft.loading = false;
        draft.firstRender = false;
        break;

      case LOAD_STUDENT_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // Change
      case CHANGE_STUDENT:
        draft.itemData = action.itemData;
        draft.error = false;
        draft.firstRender = false;
        break;

      case CHANGE_STUDENT_SUCCESS:
        draft.itemData = action.itemData;
        draft.loading = false;
        break;

      case CHANGE_STUDENT_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
    }
  });

export default studentsDetailReducer;
